$(document).ready(function() {
	var current_url = window.location.href;
	if(current_url.includes('https://rgmx.mx/products/botellas-personalizadas') || current_url.includes('https://rgmx.mx/collections/regalos/products/botellas-personalizadas')) {
		window.location.replace("/collections/botellas-personalizadas");
	}

	if(current_url == 'https://rgmx.mx/products/eventos' || current_url.includes('https://rgmx.mx/products/eventos?')) {
		window.location.replace("/pages/eventos");
	}

	if(current_url == 'https://rgmx.mx/products/fin-perfecto-en-parras' || current_url.includes('https://rgmx.mx/products/fin-perfecto-en-parras?')) {
		window.location.replace("/pages/fin-perfecto-en-parras");
	}

	if(current_url == 'https://rgmx.mx/products/eventos-corporativos' || current_url.includes('https://rgmx.mx/products/eventos-corporativos?')) {
		window.location.replace("/pages/eventos-corporativos");
	}

	if(current_url == 'https://rgmx.mx/products/caja-de-campo' || current_url.includes('https://rgmx.mx/products/caja-de-campo?')) {
		window.location.replace("/collections/caja-de-campo");
	}

	if(current_url == 'https://rgmx.mx/products/coctel-de-campo-reviews' || current_url.includes('https://rgmx.mx/products/coctel-de-campo-reviews?')) {
		window.location.replace("/collections/coctel-de-campo");
	}

	if ($(this).scrollTop() > 40) {
		$('nav').addClass('scroll-down');
		$('body').addClass('body-scroll-down');
	}

	var lastScrollTop = 0;
	function navPosition() {
		var st = $(this).scrollTop();
		if (st > lastScrollTop){
		   // downscroll code
		   $('nav, .sticky--bar').removeClass('scroll-up');
		   $('nav, .sticky--bar').addClass('scroll-down');
		   $('body').addClass('body-scroll-down');
		} else {
		  // upscroll code
			$('nav, .sticky--bar').removeClass('scroll-down');
			$('body').removeClass('body-scroll-down');
			$('nav, .sticky--bar').addClass('scroll-up');
		}

		if ($(this).scrollTop() < 40) {
			$('nav, .sticky--bar').removeClass('scroll-down');
			$('body').removeClass('body-scroll-down');
			$('nav, .sticky--bar').removeClass('scroll-up');
	    }

	    if ($(this).scrollTop() > 380) {
	    	$('.btn-fixed, svg').addClass('gray');
	    }

	    if ($(this).scrollTop() < 420) {
	    	$('.btn-fixed, svg').removeClass('gray');
	    }
		lastScrollTop = st;
	}
	$(window).scroll(function(event){
		navPosition();
	});

	$(window).scroll(function() {
	   	if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
	       //alert("near bottom!");
	    	$(".left-fixed, .right-fixed").addClass("opacity");
	   	} else {
	   		$(".left-fixed, .right-fixed").removeClass("opacity");
	   	}
	});

	$(".parent li").click(function() {
		$(this).find(".child").toggleClass("open");
		$(this).find(".brg-arrow").toggleClass("rotate");
	});

	$(".menu-open").click(function() {
		$(".sidenav").toggleClass("open");
	});

	$(".menu-close").click(function() {
		$(".sidenav").toggleClass("open");
	});


	function setCookie(name,value,days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days*24*60*60*1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	}

	function eraseCookie(name) {   
	    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

	$("#yes_legal").click(function() {
		setCookie('mayor_de_edad', true, 2);
		$(".legal-message").fadeOut();
		$(".legal-message").removeClass("show");
	    $(".legal-message").addClass("hide");
	});

	var legal = getCookie('mayor_de_edad');
	if (legal) {
		$(".legal-message").removeClass("show");
	    $(".legal-message").addClass("hide");
	} else {
		$(".legal-message").removeClass("hide");
		$(".legal-message").addClass("show");
	}

	$(".search-show").click(function(e) {
		e.preventDefault();
		$(".search-full").show();
		$("body, html").css('overflow', 'hidden');
	});

	$(".search-hide").click(function(e) {
		e.preventDefault();
		$(".search-full").hide();
		$("body, html").css('overflow', 'auto');
	});

	$(document).on('click', '.bdlr__product--qty-view', function() {
		$('nav.valign-wrapper-center, .sticky--bar').css('z-index', '1');
	});

	$(document).on('click', ".enoble_modal, .enoble_modal-close", function() {
		$('nav.valign-wrapper-center, .sticky--bar').css('z-index', '2');
	});

	function changeLanguage(val) {
		if (val == '') {
			window.location.href = window.location.origin;
		} else {
			let origin = window.location.origin;
		  	let path = window.location.pathname;
		  	let newURL = origin + val + path;
		  	window.location.href = newURL;
		}
	}

	$('#translation_sub, #translation_sub-mobile').on('change', function() {
	  if(this.value == 'es') {
	  	changeLanguage('');
	  } else {
	  	console.log('en');
	  	changeLanguage('/en');
	  }
	});

	$('#translation').on('change', function() {
	  if(this.value == 'es') {
	  	changeLanguage('');
	  } else {
	  	console.log('en');
	  	changeLanguage('/en');
	  }
	});

	$('.language-list button').click(function() {
		var current_language = $(this).data('language');
		if(current_language == 'es') {
			changeLanguage('');
		} else {
			console.log('en');
			changeLanguage('/en');
		}
	});

	$('.language-selector.mobile').click(function() {
		$('.language-selector.mobile .language-list').toggleClass('show');
	});
});